var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39981 8.4C4.39981 5.30721 6.90701 2.8 9.99981 2.8C13.0926 2.8 15.5998 5.30721 15.5998 8.4V12.1578L17.0654 14.3562C17.2291 14.6017 17.2444 14.9174 17.1051 15.1775C16.9659 15.4376 16.6948 15.6 16.3998 15.6H3.59981C3.30477 15.6 3.03368 15.4376 2.89447 15.1775C2.75525 14.9174 2.77051 14.6017 2.93417 14.3562L4.39981 12.1578V8.4Z",
    fill: "#AD533D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 14.4C8.44163 14.4 8.7998 14.7582 8.7998 15.2C8.7998 15.8627 9.33706 16.4 9.9998 16.4C10.6625 16.4 11.1998 15.8627 11.1998 15.2C11.1998 14.7582 11.558 14.4 11.9998 14.4C12.4416 14.4 12.7998 14.7582 12.7998 15.2C12.7998 16.7464 11.5462 18 9.9998 18C8.45341 18 7.1998 16.7464 7.1998 15.2C7.1998 14.7582 7.55798 14.4 7.9998 14.4Z",
    fill: "#AD533D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3998 3.6C8.3998 2.71634 9.11615 2 9.9998 2C10.8835 2 11.5998 2.71634 11.5998 3.6C11.5998 4.04183 11.2416 4.4 10.7998 4.4C10.358 4.4 9.9998 4.04183 9.9998 3.6C9.9998 4.04183 9.64163 4.4 9.1998 4.4C8.75798 4.4 8.3998 4.04183 8.3998 3.6Z",
    fill: "#AD533D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.3d4d77673814a820a4c359173d7c49d9.svg";
export { ForwardRef as ReactComponent };